export interface Step {
  Name: string
  Order: number
}

export enum BoundingBoxType {
  None = 0,
  Auto = 1,
}

export enum BackgroundType {
  None = 0,
  Remove = 1,
}
